// addresses modules
import axios from 'axios';
import { BLOG_URL, BLOG_PAGINATE_URL, BLOG_COMMENT_URL } from '../../api/url.js';

// initial state
const state = {
  blogs: [],
  selectBlogId: '',
  blogsPaginate: '',
  blogsCount: '',
}

// actions
const actions = {
  // fetchALLBlogs
  async fetchBlogs(context, page) {
    const config = {
      method: 'GET',
      url: `${BLOG_PAGINATE_URL}&page=${page}`,
    };
    await axios(config) 
    .then((response) => {
      context.commit('fetchBlogs', response.data);
    }, (err) => {
      console.log("fetchBlogs error:", err);
    })
  },
  
  // fetchBlog
  fetchBlogDetail: (context, blogId) => axios({
    method: 'GET',
    url: `${BLOG_URL}${blogId}`, 
  }),
  
  // postBlogComment
  async postBlogComment(context, [form, blogId]) {
    const config = {
      method: 'POST',
      data: form,
      url: `${BLOG_COMMENT_URL}${blogId}`,
    };
    await axios(config) 
    .then((response) => {
      console.log('postcomment: ', response);
    }, (err) => {
      console.log("postcomment error:", err);
    })
  }
};

// mutations
const mutations = {
  fetchBlogs(state, payload) {
      state.blogs = payload.record;
      state.blogsPaginate = payload.pages;
      state.blogsCount = payload.count;
  },
  updategBlogId(state, number) {
    state.selectBlogId = number
  },
}

export default {
  strict: true,
  namespaced: true,
  state,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/blog.js